/**
 * Format image count for mobile display.
 * Desktop formatting is handled directly in the hook with translations.
 * 
 * @param current - Current image index (1-based)
 * @param total - Total number of images
 * @returns Formatted string (e.g., "3/10")
 */
export function formatImageCount(current: number, total: number): string {
  return `${current}/${total}`;
}
